import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Home from '@material-ui/icons/HomeSharp';
import Devices from '@material-ui/icons/DevicesOtherSharp';
import { withRouter } from 'react-router-dom';

export const drawerWidth = 280;

const styles = () => ({
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
	},
});

const SideBar = props => {
	const { classes, open, history } = props;

	return (
		<Drawer
			className={classes.drawer}
			variant="persistent"
			anchor="left"
			key="sidebar"
			id="sidebar"
			open={open}
			classes={{
				paper: classes.drawerPaper,
			}}
		>
			<List>
				<ListItem button key="Home" onClick={() => history.push('/')}>
					<ListItemIcon>
						<Home />
					</ListItemIcon>
					<ListItemText primary="Home" />
				</ListItem>
				<ListItem button key="platform" onClick={() => history.push('/platform')}>
					<ListItemIcon>
						<Devices />
					</ListItemIcon>
					<ListItemText primary="Platforms" />
				</ListItem>
			</List>
		</Drawer>
	);
};

export default withRouter(withStyles(styles)(SideBar));
